window.hvgExperiments = window.hvgExperiments || [];

//returns true with given propability
function isTrueWithProbability(probability) {
    if (probability < 0 || probability > 1) {
        throw new Error("propability has to be between 0 to 1.");
    }
    return Math.random() < probability;
}

function pushExperiment(experiment){
    if (!experiment.name 
        || !experiment.group || typeof experiment.name !== 'string' 
        || typeof experiment.group !== 'string' || experiment.name.length<3 || experiment.group.length<1){
        return;
    } 
    window.hvgExperiments = window.hvgExperiments || [];

    try {
        let a = localStorage.getItem("hvgExperiments");
        if(a === null){
            window.hvgExperiments.push(experiment);
            localStorage.setItem("hvgExperiments", JSON.stringify(window.hvgExperiments));
        }
        else {
            try {
                tab = JSON.parse(a);
            } catch (e) {
                console.error("Failed to parse experiments from localStorage:", e);
                tab = [];
            }
            if(! tab.some( item => item.name===experiment.name )){
                tab.push(experiment);
                localStorage.setItem("hvgExperiments", JSON.stringify(tab));
                window.hvgExperiments.push(experiment);
            }
            else{
                let oryg = tab.find(item => item.name===experiment.name);
                oryg.group = experiment.group;
                localStorage.setItem("hvgExperiments", JSON.stringify(tab));
                let presentItem = window.hvgExperiments.find(item => item.name===experiment.name);
                presentItem.group=experiment.group;

            }
        }
    } catch (e) {
        console.error("localStorage is not available:", e);
    }
}

function loadExperiment(name){
    try {
        let a = localStorage.getItem("hvgExperiments");
        if (a === null){
            //console.log("KEY NOT FOUND IN STORAGE");
            return false;
        } 
        try {
            tab = JSON.parse(a);
        } catch (e) {
            console.error("Failed to parse experiments from localStorage:", e);
            tab = [];
        }
        for(let i=0; i<tab.length; i++){
            if(name === tab[i].name) {
                if (!window.hvgExperiments.some(exp => exp.name === tab[i].name)) {
                    window.hvgExperiments.push(tab[i]);
                    //console.log("FOUND IN STORAGE");
                    return true;
                }
            }
        }
    } catch (e) {
        console.error("localStorage is not available:", e);
    }
    console.log("NOT FOUND IN STORAGE");
    return false;
}


function removeFromExperiments(name){
    try {
        let a = localStorage.getItem("hvgExperiments");
        if(a !== null) {
        try {
            tab = JSON.parse(a);
            if(tab.find( item => item.name === name )){
                tab = tab.filter(item => item.name !== name);
                localStorage.setItem("hvgExperiments", JSON.stringify(tab));
                hvgExperiments = hvgExperiments.filter(item => item.name !== name);
            }
        } catch (e) {
            console.log("Failed to parse experiments from localStorage:", e);
        }
        }
    } catch (e) {
        console.error("localStorage is not available:", e);
    }
}

function getExperimentGroup( experimentName ){
    for(let i=0; i<window.hvgExperiments.length; i++){
            if(experimentName === window.hvgExperiments[i].name) {
            return window.hvgExperiments[i].group || null;
        }
    }
    return null;
}

function isInExperimentGroup( experimentName, groupName ){
    for(let i=0; i<window.hvgExperiments.length; i++){
        if(experimentName === window.hvgExperiments[i].name && window.hvgExperiments[i].group === groupName ) return true;
    }
    return false;
}


function reaasignToOtherGroup(experiment, group){
    let newAssinnment =  {"name": experiment, "group": group};
    pushExperiment(newAssinnment);
}


// SIMPLE GUIDE
// 
// To run the experiment follow that steps:
// 
// 1. design the experiment 
//      - what will you need to know to make proper decision,
//      - remember to change during the test 1 thing or one group of things that could matter
// 2. set the uniq experiment name and    
//      assign the groups like this: 

//      Let's say you need to check which footer is better - old design (no content), new design a (footer with form), new design b (footer without form 4 column), 
//      new design c (footer wihout form but 3 columns of content).

//      So the names could be: 
//     for experiment name: "footer_design" (must be uniq)
//     and for groups: no_content, with_form, 4_column, 3_column

// 3. Set the representative samples

//      a) you could deside to set equal samples for groups. 
//      in that case 25% is no_content, 25% is with_form, 25% is 4_column, 25% is  3_column

//      b) but you can also decide to set it proporionally (30% for new types only)
//      in that case you would have 70% is no_content, 10% is with_form, 10% is 4_column, 10% is  3_column

//      c) sometimes you don't have control of assignment - accept it and use properly. 
//      f.ex: You want to check banner efitenty on main site. To clasify gropu corectly you need to 
//      have in mind that desktop and mobile baner are not equal so you need also to assign grops corectly. 
//      Becouse of fact that desktop + mobile is 100% (ca.) so on desktop you will have to have: 50% group banner_a_desktop, 50% group baner_b_desktop and:
//      on mobile: 50% banner_a_mobie, 50% banner_b_mobile. You have then 100% traffic and 4 groups. 

// Remember !! that in case b results has to rescaled while analysis 

// Remember !! that in case c results has to to be analised separetly - for mobile and desktop. 

// Remember !! - the test is reliable only if big numbers theory works in the experiment and proportion you have set has been reflected 
// it has to be confirmedin proporion of hit event. )

// Remomber !! - all grops should represent ecsactly 100% SVGComponentTransferFunctionElement
// Remember !! - Structer ones set must'nt  be changed. If you hamve made a mistake - run onother experiment.

// 4. Implement conditioning display.

//      once the group assignment is ready use the hvgExperiments array to display corect content to people.
//      You will find there name of experiment and value with group name. 

// 5. After test - remove the tests from browsers.




//      SNIPPETS EXAPMPLES
//
//
// First make sure everything is removed and then add it with the order.
//
//
//       if(!loadExperiment("googlebadge")){
//         let googlebadge = {"name": "googlebadge"};
//         if(isTrueWithProbability(0.2)){
//           googlebadge.group="badge";
//         }
//         else{
//           googlebadge.group="no_badge";
//         }
//         pushExperiment(googlebadge);
//       }
//      
//       or something like this: 
//
//       if(!loadExperiment("browser_lang")){
//         let browser_lang = {"name": "browser_lang"};
//         const langCode = navigator.language.split('-')[0];
//         browser_lang.group=langCode;
//         pushExperiment(browser_lang);
//       }
//
//       If you finish the experiment remove it from browsers like this:
//
//       removeFromExperiments("googlebadge");





//CURRENT CONFIGURATION - PUT YOUR EXPERIMENTS BELOW


if(!loadExperiment("browser_lang")){ //checks if user is assigned already
    
    //creats experiment object
    let browser_lang = {"name": "browser_lang"};

    //assign user to group
    const langCode = navigator.language.split('-')[0];
    browser_lang.group=langCode;

    //adds experiment object with group assignment to the set.
    pushExperiment(browser_lang);
}


//test experiment 
// if(!loadExperiment("pdp_change")){
//     let v = {"name": "pdp_change"};
//     if(isTrueWithProbability(0.2)){
//         v.group="new_switcher";
//     }
//     else{
//         v.group="old_switcher";
//     }
//     pushExperiment(v);
// }




//GARBIDGE COLLECTOR OF PAST EXPERIMENTS


    removeFromExperiments("pdp_change");
